import * as _ from 'lodash-es';
import {forkJoin, Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {ListResponse} from '../../common/api-helpers';
import {QueryLangFilterOperator} from '../../enums/query-lang-filter-operator';
import {SortDirection} from '../../enums/sort-direction';
import {ListFilterFactory} from '../../factories/list-filter.factory';
import {Asset} from '../../models/asset';
import {CommonListFilter} from '../../models/filters/common-list-filter';
import {QueryLangFilterCriterion} from '../../models/filters/query-lang-filter-criterion';
import {AutocompleteProviderConfig} from '../autocomplete';

const ASSET_SYMBOL: keyof Asset = 'symbol';

export const autocompleteAsset = (
    getAssets: (listFilter: CommonListFilter) => Observable<ListResponse<Asset>>,
    term: string,
    config?: AutocompleteProviderConfig<Asset>
): Observable<Asset[]> => {
    const trimmedTerm = String(term).trim();

    const listFilterBase = ListFilterFactory.createWithSearchFields(
        config && config.filters || [],
        ASSET_SYMBOL,
        SortDirection.ASC,
        20
    );

    const fetch = (listFilter: CommonListFilter): Observable<Asset[]> =>
        getAssets(listFilter).pipe(
            map(listResponse => listResponse.data)
        );

    return forkJoin({
        fullMatch: trimmedTerm
                       ? fetch({
                ...listFilterBase,
                filters: [
                    new QueryLangFilterCriterion<Asset>({
                        fieldNames: [ASSET_SYMBOL],
                        operator:   QueryLangFilterOperator.EQ,
                        query:      trimmedTerm.toUpperCase()
                    }),
                    ...listFilterBase.filters
                ]
            })
                       : of<Asset[]>([]),
        normalMatch: fetch({
            ...listFilterBase,
            filters: [
                new QueryLangFilterCriterion<Asset>({
                    fieldNames: [ASSET_SYMBOL],
                    operator:   QueryLangFilterOperator.LIKE,
                    query:      term
                }),
                ...listFilterBase.filters
            ]
        })
    }).pipe(
        map(({fullMatch, normalMatch}) => {
            let result: Asset[];

            if (fullMatch.length && normalMatch.length) {
                const fullMatchDict = _.keyBy(fullMatch, asset => asset.symbol);

                result = [
                    ...fullMatch,
                    ...normalMatch.filter(asset => !fullMatchDict[asset.symbol])
                ];
            } else {
                result = [...fullMatch, ...normalMatch];
            }

            return result;
        })
    );
};
